import { cloneDeep, first, last, isEqual } from 'lodash';
import { Coordinate } from '../../types';

export type MapLocalStorage = {
  activeMapType: string;
}

export function toGeoJSON(coordinates: google.maps.LatLngLiteral[], addTailVertex = true): [number, number][] {
  const coordinatesCopy = cloneDeep(coordinates);

  if (addTailVertex && !isEqual(first(coordinatesCopy), last(coordinatesCopy))) {
    coordinatesCopy.push(first(coordinatesCopy)); // close the polygon (needed for a polygon GEOJson )
  }

  return (coordinatesCopy || []).map(entry => {
    return [entry.lng, entry.lat];
  });
}

export function fromGeoJSON(coordinates: [number, number][], removeClosingPolygonVertex = false): google.maps.LatLngLiteral[] {
  const result = (coordinates || []).map(entry => {
    return {
      lng: entry[0],
      lat: entry[1]
    };
  });

  if (removeClosingPolygonVertex && result.length > 1 && isEqual(first(result), last(result))) {
    result.pop(); // remove last element  (provided by a GEOJson polygon)
  }

  return result;
}

export function toWGS84(coordinates: google.maps.LatLngLiteral[]): Coordinate[] {
  return (coordinates || []).map(c => ([c.lng, c.lat]));
}

export function fromWGS84(coordinates: Coordinate[]): google.maps.LatLngLiteral[] {
  return (coordinates || []).map(c => ({lat: c[1], lng: c[0]}));
}

export function saveMapLocalStorage(key: string, data: Partial<MapLocalStorage>) {
  const existingData = getMapLocalStorage(key);

  localStorage.setItem(key, JSON.stringify({...(existingData ?? {}), ...data}));
}

export function getMapLocalStorage(key: string): Partial<MapLocalStorage> | null {
  const data = localStorage.getItem(key);

  if (data) {
    return JSON.parse(data);
  } else {
    return null;
  }
}
